<template>
  <div>
      <div class="news-editor">

          <div class="editor-area">
              <div class="editor-area__header">
                  <h2 class="editor-area__title">Área de edição</h2>
                  <button class=" button-default button-default--save-template" @click="saveTemplate">Salvar template</button>
              </div>

              <div class="editor-layout-1">
                  <CEditorLayout1 :selectedSectionToEdit="selectedSectionToEdit" :data.sync="currentData"/>
              </div>
          </div>

          <div class="layout-area">
              <CMailLayout1 :data="currentData" :selectedSectionToEdit.sync="selectedSectionToEdit"/>
          </div>
      </div>
  </div>
</template>

<script>
import CEditorLayout1 from './components/c-editor-layout-1.vue'
import CMailLayout1 from './components/c-maill-layout-1.vue'
import axios from 'axios';
import Swal from 'sweetalert2';
import initialData from './initialData.JS';

export default {
    name: 'Layout-1',
    components: { CEditorLayout1, CMailLayout1, initialData },
    props: ['id_news', 'list', 'title', 'templateId', 'send_date', 'templateNews'],
    data() {
        return {
            currentHtml: null,
            currentData: initialData,
            selectedSectionToEdit: '',
            template_base_id: null,
            appRoot: _ROOT_PATH
        }    
    },
    beforeMount() {
        if (this.templateNews && this.id_news > 0) {
            this.currentData = JSON.parse(this.templateNews);
        }
    },
    methods: {
        saveTemplate() {
            this.selectedSectionToEdit = '';
            var _this                  = this;
            this.currentHtml           = document.getElementById('email-layout').outerHTML;
            this.currentData.html      = this.currentHtml;
            const dataToSave           = this.currentData;

            if (!this.title || !this.templateId || !this.list[0] || !this.send_date) {
                Swal.fire({
                    title: 'Oops!',
                    text: 'Todos os campos são obrigatórios, verifique!',
                    type: 'error',
                    confirmButtonColor: '#d63030',
                    confirmButtonText: 'Ok!'
                });
            } else {
                if(this.id_news) {
                    this.editTemplate(_this, dataToSave);
                } else {
                    this.createTemplate(_this, dataToSave);
                }
            }
        },
        createTemplate(_this, dataToSave) {
            axios.post(_ROOT_PATH + '/admin/news-atlas/cadastrar', {
                'title'             : _this.title,
                'template'          : JSON.stringify(dataToSave),
                'template_compiled' : this.currentHtml,
                'send_date'         : this.send_date,
                'list'              : this.list,
                'template_base_id'  : _this.template_base_id == null ? _this.templateId : _this.template_base_id
            }).then(function (response) {
                Swal.fire({
                    title: 'Sucesso!',
                    text: 'News salva com sucesso!',
                    type: 'success',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Obrigado!'
                }).then((result) => {
                    window.location.href = "/admin/news-atlas/";
                });
            }).catch(function (error) {
                Swal.fire({
                    title: 'Oops!',
                    text: 'Ocorreu um erro ao salvar o layout.',
                    type: 'error',
                    confirmButtonColor: '#d63030',
                    confirmButtonText: 'Ok!'
                });
            });
        },
        editTemplate(_this, dataToSave) {
            axios.post(_ROOT_PATH + '/admin/news-atlas/editar/' + this.id_news, {
                'title'             : _this.title,
                'template'          : JSON.stringify(dataToSave),
                'template_compiled' : this.currentHtml,
                'send_date'         : this.send_date,
                'list'              : this.list,
                'template_base_id'  : _this.template_base_id == null ? _this.templateId : _this.template_base_id
            }).then(function (response) {
                Swal.fire({
                    title: 'Sucesso!',
                    text: 'News salva com sucesso!',
                    type: 'success',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Obrigado!'
                }).then((result) => {
                    window.location.href = "/admin/news-atlas/";
                });
            }).catch(function (error) {
                Swal.fire({
                    title: 'Oops!',
                    text: 'Ocorreu um erro ao salvar o layout.',
                    type: 'error',
                    confirmButtonColor: '#d63030',
                    confirmButtonText: 'Ok!'
                });
            });
        }
    }
}
</script>

<style src="../style.scss" lang="scss" scoped></style>